// Shared UI constants
export const ANIMATION = {
    LEAD_GATE_FADE_OFFSET_PX: 30,
    COVER_FADE_OFFSET_PX: 30,
    PAGE_TRANSITION_MS: 450,
};

export const ICON_SIZE = {
    INLINE_SM: 13,
    INLINE_MD: 14,
    INLINE_LG: 16,
};

export const STORAGE_KEYS = {
    LEAD: "emerald_lead",
};
